import View from './view';

function MatrizItensImpactados() {
  return (
      <View />
  );
}


export default MatrizItensImpactados;
